module.exports = __webpack_public_path__ + "img/SKMJ_ex4.9b821cea.jpg";